const products_on_page = document.querySelector('product-list');
const nextUrl = document.getElementById('paginateNext');
let next_url = nextUrl?.dataset.nextUrl;
const load_more_btn = document.getElementsByClassName('load-more_btn')[0];

async function getNextPage() {
  try {
    const res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  if (!next_url) return;
  const nextPage = await getNextPage();
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
  const productgrid = nextPageDoc.querySelector('.product-list');
  const new_products = [...productgrid.querySelectorAll('.product-card')];
  const newUrl = nextPageDoc.getElementById('paginateNext');
  const new_url = newUrl?.dataset.nextUrl;
  next_url = new_url;
  if (next_url) {
    load_more_btn.style.display = 'flex';
  } else {
    load_more_btn.style.display = 'none';
  }
  new_products.forEach(product => {
    products_on_page.appendChild(product);
  });
}

load_more_btn.addEventListener('click', loadMoreProducts);